export default __webpack_public_path__ + "static/media/check.1070b266.svg";